const Grid = function () 
{

    const changeLayout = function(el) {

        let gridLayout = el.attr('data-layout');

        if( gridLayout == 3 ) {
            el.attr('data-layout',4);
        } else {
            el.attr('data-layout',3);
        }

        el.closest('.wrapper-grid').find('.col').removeClass(function (index, css) {
            return (css.match (/\bcol-md-\S+/g) || []).join(' ');
       });
       el.closest('.wrapper-grid').find('.col').addClass("col-md-" + gridLayout)

    }
    
    return {
        init : function() {
            $(document).on('click', '.nav-grid-layout', function () {
                changeLayout( $(this) );
            });

        }
    }

}();

module.exports = Grid;